import { createSlice } from "@reduxjs/toolkit";
import { THEME_CONFIG } from "./../configs/AppConfig";

const initialState = {
  ...THEME_CONFIG,
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    onMobileNavToggle(state, action) {
      state.mobileNav = action.payload;
    },
    toggleCollapsedNav(state, action) {
      state.navCollapsed = action.payload;
    },
    onLocaleChange(state, action) {
      state.locale = action.payload;
    },
    onNavStyleChange(state, action) {
      state.sideNavTheme = action.payload;
    },
    onNavTypeChange(state, action) {
      state.navType = action.payload;
    },
    onTopNavColorChange(state, action) {
      state.topNavColor = action.payload;
    },
    onHeaderNavColorChange(state, action) {
      state.headerNavColor = action.payload;
    },
  },
});

export const {
  onMobileNavToggle,
  toggleCollapsedNav,
  onLocaleChange,
  onNavStyleChange,
  onNavTypeChange,
  onTopNavColorChange,
  onHeaderNavColorChange
} = themeSlice.actions;

export default themeSlice.reducer;
